export const locale = {
    lang: 'es',
    data: {
      'WEB_COMPANY_PROFILE': {
        'TIT_WCP': 'Perfil de la empresa en la web',
        'TIT_WCP_DAT': 'Datos de acceso',
        'HELP':'Ayuda',
        'CHAN_INF':'Cargando información',
        'EnlaceWCP':'Copiar enlace para ingresar al perfil de empresa',
        'ClaveWCP':'Copiar clave para ingresar al perfil de empresa',
        'PORDUC_CER':{
          '40':'Certificar 3.0',
          '1':'Certificar',
          '20':'Certificar 2.0',
          '70': 'Resultados GoFlow'
        },
        'ESTA_WEB_CP':{
          'false':'No publico',
          'true':'Publico',
        },
        'MODAL':{
          'TIT_MOD':'¿Cuál es la razón de no publicarlo?',
          'BTN_CONT':'Continuar',
          'BTN_CANC':'Cancelar',
          'RAISON_OBLIG':'Para continuar es necesario ingresar la razon de no publicarlo',
          'TIT_CONDI_US':'Condiciones de uso',
          'TEX1_CONDI_US':'Al momento de hacer público el perfil de la empresa, se publicará en la página de Great Place To Work(r) con la información que se haya configurado.Great Place to Work(r) no tiene responsabilidad respecto al contenido, ya que los datos publicados son resultado de información que la misma empresa ha subido en las plataformas destinadas para ello.',
          'TEX2_CONDI_US':'También la empresa acepta esta información se subirá a los diversos motores de búsqueda que se han contratado para incrementar la difusión de las mejores empresas para trabajar que han sido certificadas por Great Place To Work(r)',
          'TEX3_CONDI_US':'En cualquier momento, la empresa podrá regresar el perfil de empresa a modo privado, lo que hará que ya no aparezca en la lista de empresas certificadas, sin embargo, Great Place To Work(r) no podrá eliminar la indexación que los motores de búsqueda hayan hecho, por lo que es probable que durante algún tiempo siga apareciendo el nombre de la empresa dentro de los resultados de la búsqueda en los diferentes motores de búsqueda con los que Great Place To Work trabaje.',
          'TEX4_CONDI_US':'La publicación o no publicación de este perfil de empresa es responsabilidad únicamente de la empresa.',
          'REA_TEX_CONDI_US':'Para confirmarlo, escriba el siguiente texto.',
          'NO_DISPO_ARCHI':'El archivo no está disponible',
        }

      }
    }
};
